import { TFunction } from "next-i18next";

import { UrlsConfig } from "configs/urlsConfig";
import { PriceBlockContent } from "components/Relaunch/PriceBlock/PriceBlock.types";

const pageContent = (t: TFunction): PriceBlockContent => {
    return {
        title: t("title"),
        description: t("description", ""),
        cta: {
            text: t("cta"),
            link: UrlsConfig.UNIVERSAL_FORM,
        },
    };
};

export default pageContent;
